const PageContent = (props: { children: any }) => {
  return <div className="page-content">{props.children}</div>;
};
export default PageContent;
